import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
import { Table, TableBody } from '@mui/material';
import { OpenThermVariableName } from 'openTherm';
import { OTFaultGroup } from 'console/shared/components/dialogs/ot-boiler-state/components/table/fault';
import { OTStatusGroup } from 'console/shared/components/dialogs/ot-boiler-state/components/table/status';
import { OTBoilerGroup } from 'console/shared/components/dialogs/ot-boiler-state/components/table/configuration';
import { BoilerAdapterProtocol } from 'z3k-config';
import { OTBSBStatusGroup } from 'console/shared/components/dialogs/ot-boiler-state/components/table/bsb-status';
import { OTHeatingFlags, OTHeatingGroup, } from 'console/shared/components/dialogs/ot-boiler-state/components/table/heating';
import { OTDHWFlags, OTDHWGroup, } from 'console/shared/components/dialogs/ot-boiler-state/components/table/dhw';
import { OTOtherGroup, OTOtherStringFlags, OTOtherTempFlags, } from 'console/shared/components/dialogs/ot-boiler-state/components/table/other';
import { otHasError } from 'console/shared/components/banners/failure/components/fail-card/utils';
export const OTBoilerStateTable = memo(function OTBoilerStateTable(props) {
    const { ot_state, boiler_adapter_type, not_available_ot_flags, boiler_model, boiler_adapter_status, } = props;
    const _not_available_ot_flags = not_available_ot_flags ?? new Set();
    const heating_group = new Map(Object.entries(ot_state)
        .map((item) => [
        item[0],
        item[1],
    ])
        .filter(([flag]) => OTHeatingFlags.has(flag))
        .filter(([flag]) => !_not_available_ot_flags.has(flag)));
    const dhw_group = new Map(Object.entries(ot_state)
        .map((item) => [
        item[0],
        item[1],
    ])
        .filter(([flag]) => OTDHWFlags.has(flag))
        .filter(([flag]) => !_not_available_ot_flags.has(flag)));
    const temp_other_group = new Map(Object.entries(ot_state)
        .map((item) => [
        item[0],
        item[1],
    ])
        .filter(([flag]) => OTOtherTempFlags.has(flag)));
    const string_other_group = new Map(Object.entries(ot_state)
        .map((item) => [
        item[0],
        item[1],
    ])
        .filter(([flag]) => OTOtherStringFlags.has(flag)));
    const not_available_modulation = _not_available_ot_flags.has(OpenThermVariableName.rml);
    const not_available_pressure = _not_available_ot_flags.has(OpenThermVariableName.wp);
    return (_jsx(Table, { size: "small", children: _jsxs(TableBody, { children: [ot_state[OpenThermVariableName.ff] != null &&
                    otHasError(boiler_adapter_type, ot_state, boiler_adapter_status) && (_jsx(OTFaultGroup, { ot_value: ot_state[OpenThermVariableName.ff], ot_state: ot_state, boiler_model: boiler_model, boiler_type: boiler_adapter_type })), ot_state[OpenThermVariableName.s] != null && (_jsx(OTStatusGroup, { ot_value: ot_state[OpenThermVariableName.s], modulation: not_available_modulation
                        ? undefined
                        : ot_state[OpenThermVariableName.rml], pressure: not_available_pressure
                        ? undefined
                        : ot_state[OpenThermVariableName.wp] })), ot_state[OpenThermVariableName.sc] != null && (_jsx(OTBoilerGroup, { ot_value: ot_state[OpenThermVariableName.sc] })), boiler_adapter_type != null &&
                    boiler_adapter_type == BoilerAdapterProtocol.BSB &&
                    ot_state[OpenThermVariableName.rbp] != null && (_jsx(OTBSBStatusGroup, { ot_value: ot_state[OpenThermVariableName.rbp] })), heating_group.size > 0 && _jsx(OTHeatingGroup, { ot_value: heating_group }), dhw_group.size > 0 && _jsx(OTDHWGroup, { ot_value: dhw_group }), (temp_other_group.size > 0 ||
                    string_other_group.size > 0 ||
                    ot_state[OpenThermVariableName.sv] != null ||
                    ot_state[OpenThermVariableName.mv] != null ||
                    ot_state[OpenThermVariableName.mrml] != null ||
                    ot_state[OpenThermVariableName.b]) != null && (_jsx(OTOtherGroup, { temp_values: temp_other_group, string_values: string_other_group, boiler_version: ot_state[OpenThermVariableName.sv], master_version: ot_state[OpenThermVariableName.mv], max_modulation: ot_state[OpenThermVariableName.mrml], temp_range: ot_state[OpenThermVariableName.b] }))] }) }));
});
